import { Component, input } from '@angular/core';
import { PreviewDataWrapperComponent } from '../../preview-data-wrapper/preview-data-wrapper.component';

@Component({
  selector: 'app-preview-organization-subject',
  imports: [PreviewDataWrapperComponent],
  templateUrl: './preview-organization-subject.html',
  styleUrl: './preview-organization-subject.scss',
})
export class PreviewOrganizationSubject {
  public readonly identyfikator = input<string>();
}
